export default __webpack_public_path__ + "static/media/vase@2x.6f9330b4.jpg";